import BasePropertyView from 'BasePropertyView.js';
import Template         from 'workflow/properties/main/description.ejs';

//=====================================================================
//
// An instance of this view represents a description in workflow section.
//
// Maty Rocha, July 19, 2017
//
//=====================================================================

class MainDescriptionView extends BasePropertyView {

    initialize( opts ) {

        this.options = opts || {};
        this.template = Template;
        this.tagName = 'div';
        this.id = opts.el;

        this.events = {
            'change textarea'               : 'updateAttributes',
            'blur textarea'                 : 'lostFocus',
            'focus textarea'                : 'getFocus'
        };

        this.listenTo(this.model, 'change', this.render);

        return this;
    }

   updateAttributes(ev) {
        ev.preventDefault();
        const propName = ev.currentTarget.name;
        const propVal  = ev.currentTarget.value;
        this.model.set( propName, propVal );
    }


    render() {
        if(this.template) {
            this.$el.html(this.template(this.model.toJSON()));
        }

        this.delegateEvents();
        return this;
    }

}

export default MainDescriptionView;
